import { useState } from "react"

export const VariableStatements =() => {
    const [state, setState] = useState({
        number: '',
        search_value:"",
        date:"",
        user_id: '',
        user_name: '',
        account_id:'',
        account_name:'',
        project_id: "",
        project_name: "",
        production_manager: "",
        production_crew: [],
        startDate: "",
        endDate: "",
        open: false,
        openEdit: false,
        arr1: [],
        Load: false,
        openDetails: false,
    })
    const setStateCustom = (variableName, value) => {
        setState((prevState) => ({
            ...prevState,
            [variableName]: value,
        }));
    };
    const setLoad = (value) => {
        setState((prevState) => ({
            ...prevState,
            Load: value,
        }));
    };
    const setOpen = (value) => {
        setState((prevState) => ({
            ...prevState,
            open: value,
        }));
    };
    const setOpenDetails = (value) => {
        setState((prevState) => ({
            ...prevState,
            openDetails: value,
        }));
    };
    const setopenEdit = (value) => {
        setState((prevState) => ({
            ...prevState,
            openEdit: value,
        }));
    };
    const handleEdit= (event, arr) => {
        event.preventDefault();
        setState((prevState) => ({
            ...prevState,
            arr1: arr,
            openEdit: true
        }));
    }
    const handleChangeDate = (range) => {
        const [startDatee, endDatee] = range;
        setState((prevState) => ({
            ...prevState,
            startDate: startDatee,
            endDate: endDatee
        }));
    };
  return {
    ...state,
    state,
    setState,
    handleEdit,
    setOpen,
    setopenEdit,
    setStateCustom,
    setLoad, handleChangeDate,setOpenDetails
  }
}

